export default __webpack_public_path__ + "static/media/warning-point.98b02f0f.svg";